export const MODAL_NONE = 'MODAL_NONE'

export const MODAL_AUTH = 'MODAL_AUTH'
export const MODAL_AUTH_VERIFY_EMAIL = 'MODAL_AUTH_VERIFY_EMAIL'
export const MODAL_AUTH_SETUP_ACCOUNT = 'MODAL_AUTH_SETUP_ACCOUNT'
export const MODAL_AUTH_FORGOT_PASSWORD = 'MODAL_AUTH_FORGOT_PASSWORD'
export const MODAL_AUTH_RESET_PASSWORD = 'MODAL_AUTH_RESET_PASSWORD'

export const MODAL_EXPORT_PNG = 'MODAL_EXPORT_PNG'
export const MODAL_EXPORT_XML = 'MODAL_EXPORT_XML'
export const MODAL_EXPORT_CSV = 'MODAL_EXPORT_CSV'
export const MODAL_EXPORT_SITEMAP = 'MODAL_EXPORT_SITEMAP'
export const MODAL_EXPORT_FIGMA = 'MODAL_EXPORT_FIGMA'
export const MODAL_EXPORT_WP = 'MODAL_EXPORT_WP'
export const MODAL_EXPORT_PROMPT = 'MODAL_EXPORT_PROMPT'

export const MODAL_SUBSCRIBE = 'MODAL_SUBSCRIBE'

export const MODAL_PRICING = 'MODAL_PRICING'
export const MODAL_SHARE = 'MODAL_SHARE'
export const MODAL_SCHEDULE_CRAWL = 'MODAL_SCHEDULE_CRAWL'
export const MODAL_BLOCK = 'MODAL_BLOCK'
export const MODAL_SYMBOL = 'MODAL_SYMBOL'
export const MODAL_BLOCK_CONTENT_VIEW = 'MODAL_BLOCK_CONTENT_VIEW'
export const MODAL_PROJECT_INFORMATION = 'PROJECT_INFORMATION'
export const MODAL_LEAVE_FEEDBACK = 'MODAL_LEAVE_FEEDBACK'
export const SURVEY_CANCEL = 'SURVEY_CANCEL'
export const IMPORT_PROJECT = 'IMPORT_PROJECT'
export const MODAL_REPORT_PROJECT = 'MODAL_REPORT_PROJECT'
export const IMPORT_SELECT_URLS = 'IMPORT_SELECT_URLS'
export const IMPORT_PROJECT_CRAWLER_LOADING = 'IMPORT_PROJECT_CRAWLER_LOADING'
export const IMPORT_PROJECT_CRAWLER_ERROR = 'IMPORT_PROJECT_CRAWLER_ERROR'
export const IMPORT_PROJECT_MULTIPLE_SITEMAPS =
  'IMPORT_PROJECT_MULTIPLE_SITEMAPS'
export const MODAL_TEAM_SETTINGS = 'MODAL_TEAM_SETTINGS'
export const MODAL_INTEGRATIONS = 'MODAL_INTEGRATIONS'
export const MODAL_GA4_PROPERTY = 'MODAL_GA4_PROPERTY'
export const MODAL_NEW = 'MODAL_NEW'
export const MODAL_NEW_GENERATE_PROJECT = 'MODAL_NEW_GENERATE_PROJECT'

export const MODAL_SAVE_AS_TEMPLATE = 'MODAL_SAVE_AS_TEMPLATE'

export const MODAL_PLAN_UPGRADE_SUCCESSFUL = 'MODAL_PLAN_UPGRADE_SUCCESSFUL'
export const MODAL_TEAM_UPGRADE_SUCCESSFUL = 'MODAL_TEAM_UPGRADE_SUCCESSFUL'
export const MODAL_PLAN_DOWNGRADED = 'MODAL_PLAN_DOWNGRADED'
export const MODAL_PLAN_CHURN = 'MODAL_PLAN_CHURN'

export const MODAL_NODE_GALLERY_FIGMA_LINK = 'MODAL_NODE_GALLERY_FIGMA_LINK'

export const MODAL_PUBLISH = 'MODAL_PUBLISH'
export const MODAL_DELETE_ACCOUNT = 'MODAL_DELETE_ACCOUNT'

export const SEO_EXPORT_AS_CODE = 'SEO_EXPORT_AS_CODE'
export const SEO_PREVIEW = 'SEO_PREVIEW'

export const MODAL_UPGRADE_PLAN = 'MODAL_UPGRADE_PLAN'

export const MODAL_PROJECT_TRANSFER = 'MODAL_PROJECT_TRANSFER'

export const MODAL_CREATE_API_KEY = 'MODAL_CREATE_API_KEY'
export const MODAL_API_KEY_CREATED = 'MODAL_API_KEY_CREATED'

export const MODAL_FOLDER_VISIBILITY = 'MODAL_FOLDER_VISIBILITY'

export const MODAL_CHANGE_EMAIL_OTP = 'MODAL_CHANGE_EMAIL_OTP'

export const MODAL_PROJECT_NOTIFICATIONS = 'MODAL_PROJECT_NOTIFICATIONS'
